// -----------------------------------------------------------------------------
// Scripts for sticky submenu
// -----------------------------------------------------------------------------

function stickySubmenuBanner() {

  var subMenu = $('.child-pages');
  var header = $('.header').outerHeight();


  if ( ($('.single-offer-child-pages').length > 0) || ($('.about-us-child-pages').length > 0) ) {
  
    if ($('.single-offer-child-pages').length > 0) {
      var banner = $('.single-offer-child-pages');
    }
    if ($('.about-us-child-pages').length > 0) {
      var banner = $('.about-us-child-pages');
    }

    var bannerHeight = banner.outerHeight();
    var bannerTop = banner.offset().top;
    var main = $('.main').outerHeight();

    $(window).scroll(function () {
      if ($(this).scrollTop() > (bannerHeight + bannerTop - header)) {
        subMenu.addClass('child-pages--sticky');
        subMenu.css('top', '58px');
      } else {
        subMenu.removeClass('child-pages--sticky');
      }
    });

      if ( $(this).scrollTop() > (main - header + 40)) {
        subMenu.addClass('child-pages--hidden');
      }
      else {
        subMenu.removeClass('child-pages--hidden');
      }
    }

  }